import { createFileRoute, redirect } from '@tanstack/react-router';
import { sessionQueryOptions } from '~/lib/queries/session';
import { resolveLandingRoute } from '~/lib/landing';

// The bare entry point never renders: `beforeLoad` resolves the session
// server-side and routes signed-in users to their landing surface (Modeling, or
// Uploads when the org has no loans yet), everyone else to /sign-in — no
// render-time <Navigate>, no flash.
export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions());
    if (session) {
      throw redirect({ to: await resolveLandingRoute(context.queryClient) });
    }
    throw redirect({ to: '/sign-in' });
  },
});
